import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from "prop-types";
import {
	sendForms,
	clearForms,
} from '../../../actions';

import Button from '@material-ui/core/Button';
import ForwardICon from '@material-ui/icons/Forward';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';

import CloseIcon from '@material-ui/icons/Close';
import AlertDialog from "../dialog/alert-dialog";
import Progress from "../../containers/progress";


const styles = theme => ({
	singInButton: {
		marginRight: theme.spacing.unit,
	},
	textField:{
		width:'100%',
		marginBottom:15
	},
	button: {
		margin: theme.spacing.unit,
		display:'inline-block',
		color:"#FFFFFF"
	},
	closeIcon:{
		position:'absolute',
		top:10,
		right:10,
	},
	cancelButton: {
		float:'right',
		marginRight: 20
	},
	error_text:{
		color:'#f44336'
	}
});


class contact extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {
			isClose:false,
			inputData : {
				company_name : '',
				names : '',
				furigana : '',
				tel : '',
				email : '',
				content:'',
			},
			errors:{
				names : false,
				furigana : false,
				tel : false,
				email : false,
				content:false,
			},
			errorText:{
				names : '',
				furigana : '',
				tel : '',
				email : '',
				content:'',
			},
			error : null,
		}
	}

	
	
	_onClickSubmit(){
		const inputData = this.state.inputData;

		const company_name_is_error = inputData.company_name === "";
		const company_name_error_text = company_name_is_error ? "必須入力です" : "";

		const names_is_error = inputData.names === "";
		const names_error_text = names_is_error ? "必須入力です" : "";

		const furigana_is_error = inputData.furigana === "";
		const furigana_error_text = furigana_is_error ? "必須入力です" : "";

		let tel_is_error = inputData.tel === "";
		let tel_error_text = tel_is_error ? "必須入力です" : "";

		if(!tel_is_error){
			const tel = inputData.tel.replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi,'');
			tel_is_error = !(tel.match(/^(0[0-9]0[0-9]{8}|0[0-9][0-9][0-9]{7})$/));
			tel_error_text = tel_is_error ? "電話番号が誤りです" : "";
		}

		let email_is_error = inputData.email === "";
		let email_error_text = email_is_error ? "必須入力です" : "";
		if(!email_is_error){
			email_is_error = inputData.email.search(/[\w.\-]+@[\w\-]+\.[\w.\-]+/) === -1;
			email_error_text = email_is_error ? "メールアドレスが誤りです" : "";
		}

		const contents_is_error = inputData.content === "";
		const contents_error_text = contents_is_error ? "必須入力です" : "";

		const submit_disabled = company_name_is_error
			|| names_is_error
			|| furigana_is_error
			|| tel_is_error
			|| email_is_error
			|| contents_is_error;

		const errors = {
			company_name : company_name_is_error,
			names : names_is_error,
			furigana : furigana_is_error,
			tel : tel_is_error,
			email : email_is_error,
			content:contents_is_error,
		};
		const errorText = {
			company_name : company_name_error_text,
			names : names_error_text,
			furigana : furigana_error_text,
			tel : tel_error_text,
			email : email_error_text,
			content:contents_error_text,
		};


		this.setState({
			errors,
			errorText
		});

		if(!submit_disabled){
			this.sendMessage();
		}
	}

	_onClickCancel(){
		if(this.props.afterCloseFunc) this.props.afterCloseFunc();
	}

	sendMessage=()=>{
		const {dispatch} = this.props;
		dispatch(sendForms({
			inputData : this.state.inputData
		}))
	};
	
	_handleChange(event) {
		let inputData = this.state.inputData;
		switch (event.target.name) {
			case 'company_name':
				inputData.company_name = event.target.value;
				break;
			case 'names':
				inputData.names = event.target.value;
				break;
			case 'furigana':
				inputData.furigana = event.target.value;
				break;
			case 'tel':
				inputData.tel = event.target.value;
				break;
			case 'email':
				inputData.email = event.target.value;
				break;
			case 'content':
				inputData.content = event.target.value;
				break;
			default:
				break;
		}
		this.setState({
			inputData
		});
	}
	
	_handleKeyPress(event){
		if(event.key !== 'Enter'){
			return
		}
		switch (event.target.name) {
			case 'company_name':
				this.names.focus();
				break;
			case 'names':
				this.furigana.focus();
				break;
			case 'furigana':
				this.tel.focus();
				break;
			case 'tel':
				this.email.focus();
				break;
			case 'email':
				this.content.focus();
				break;
			default:
				break;
		}
	}

	handleClose = () => {
		if(this.props.afterCloseFunc) this.props.afterCloseFunc();
	};

	okFunction = () =>{
		const {dispatch} = this.props;
		dispatch(clearForms());
		if(this.props.afterCloseFunc) this.props.afterCloseFunc();
	};
	ngFunction = () =>{
		const {dispatch} = this.props;
		dispatch(clearForms());
	};


	
	render () {
		const { classes,forms } = this.props;
		const {inputData,errors,errorText} = this.state;


		const openCompleteDialog = forms.isComplete && !(forms.isError);
		const openErrorDialog = forms.isComplete && forms.isError;


		const Prog = () =>{
			return(
				forms.isFetching && <Progress/>
			);
		};

		return ([
			<Prog key={0} />,
			<div className="over_rays" key={1}>
				<div className={classes.closeIcon}>
					<IconButton color={"primary"} className={classes.button} aria-label="CLOSE"
								onClick={this.handleClose}>
						<CloseIcon/>
					</IconButton>
				</div>

				<div className="contact_form_main_box">
					<h2><i className="material-icons">
						mail_outline
					</i>お問い合わせフォーム</h2>
					<p className={classes.error_text}>
						※印は必須入力です
					</p>
					<div className="contact_form_inner">
						<TextField
							error={errors.company_name}
							label="御社名 ※"
							placeholder="御社名"
							className={classes.textField}
							onKeyPress={this._handleKeyPress.bind(this)}
							onChange={this._handleChange.bind(this)}
							name="company_name"
							inputRef={field => this.company_name = field}
							inputProps={{
								maxLength:20
							}}
							autoFocus={true}
							helperText={errorText.company_name}
						/>

						<TextField
							error={errors.names}
							label="お名前 ※"
							placeholder="お名前"
							className={classes.textField}
							onKeyPress={this._handleKeyPress.bind(this)}
							onChange={this._handleChange.bind(this)}
							name="names"
							inputRef={field => this.names = field}
							inputProps={{
								maxLength:20
							}}
							helperText={errorText.names}
						/>

						<TextField
							error={errors.furigana}
							label="フリガナ ※"
							placeholder="フリガナ"
							className={classes.textField}
							onKeyPress={this._handleKeyPress.bind(this)}
							onChange={this._handleChange.bind(this)}
							name="furigana"
							inputRef={field => this.furigana = field}
							inputProps={{
								maxLength:20
							}}
							helperText={errorText.furigana}

						/>

						<TextField
							error={errors.tel}
							label="直通の電話番号 ※"
							placeholder="直通の電話番号"
							className={classes.textField}
							onKeyPress={this._handleKeyPress.bind(this)}
							onChange={this._handleChange.bind(this)}
							name="tel"
							inputRef={field => this.tel = field}
							inputProps={{
								maxLength:20
							}}
							helperText={errorText.tel}
						/>

						<TextField
							error={errors.email}
							label="メールアドレス ※"
							placeholder="メールアドレス"
							className={classes.textField}
							onKeyPress={this._handleKeyPress.bind(this)}
							onChange={this._handleChange.bind(this)}
							name="email"
							inputRef={field => this.email= field}
							inputProps={{
								maxLength:50
							}}
							helperText={errorText.email}
						/>

						<TextField
							error={errors.content}
							multiline={true}
							rows={5}
							rowsMax={10}
							label="内容 ※"
							placeholder="内容を入力"
							className={classes.textField}
							onKeyPress={this._handleKeyPress.bind(this)}
							onChange={this._handleChange.bind(this)}
							name="content"
							inputRef={field => this.content= field}
							helperText={errorText.content}
						/>
					</div>
					<div className="btn_area clearfix">
						<Button variant="contained" color="primary" className="fl_right" onClick={this._onClickSubmit.bind(this)}>
							<ForwardICon className={classes.singInButton} />
							送信
						</Button>
						<Button variant="contained" className={classes.cancelButton} onClick={this._onClickCancel.bind(this)}>
							キャンセル
						</Button>
					</div>
					

				</div>
			</div>,
			<AlertDialog key={2}
				open={openCompleteDialog}
				title={"送信完了"}
				text={"お問い合わせの送信が完了しました"}
				isOnlyOK={true}
				okFunction={this.okFunction}
			/>,
			<AlertDialog key={3}
				open={openErrorDialog}
				title={"送信エラー"}
				text={
					"現在お問い合わせフォームがご利用いただけません。\n"+
					"お手数ですが、下記メールアドレスに直接お問い合わせください"
				}
			 	links={{"text":forms.system_mail,"href":"mailto:"+forms.system_mail}}
				isOnlyOK={true}
				okFunction={this.ngFunction}
			/>
		]);
	}
}

contact.propTypes = {
	afterCloseFunc:PropTypes.func
};
function mapStateToProps(state) {
	return {
		auth: state.auth,
		forms : state.forms
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(contact);



// WEBPACK FOOTER //
// ./src/common/components/form/contact.js